import React from "react";
import BoxAufkleber from "./Components/BoxAufkleber";
import PreisBerechnerAufkleber from "./Components/PreisBerechnerAufkleber";
import Form from "./Components/Form";
import ColorPicker from "./Components/ColorPicker";

import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import styled from "styled-components";

const ListItem = styled.div`
  display: flex;
  align-items: center;
  input {
    width: 30rem;
    max-width: 75vw;
  }
  p {
    margin: 0;
    padding: 1rem;
  }
  .color-box {
    margin: 0rem 1rem;
    padding: 1rem;
    #color-palette {
      z-index: 999;
    }
  }
`;

const variantNumber = [
  31853055541366,
  31853055574134,
  31853055606902,
  31853055639670,
  31853055672438,
  31853055705206,
  31853055737974,
  31853055770742,
  31853055803510,
  31853055836278,
  31853055869046,
  31853055901814,
  31853055934582,
  31853055967350,
  31853056000118,
  31853056032886,
  31853056065654,
  31853056098422,
  31853056131190,
  31853056163958,
  31853056196726,
  31853056229494,
  31853056262262,
  31853056295030,
  31853056327798,
  31853056360566,
  31853056393334,
  31853056426102,
  31853056458870,
  31853056491638,
  31853056524406,
  31853056557174,
  31853056589942,
  31853056622710,
  31853056655478,
  31853056688246,
  31853056721014,
  31853056753782,
  31853056786550,
  31853056819318,
  31853056852086,
  31853056884854,
  31853056917622,
  31853056950390,
  31853056983158,
  31853057015926,
  31853057048694,
  31853057081462,
  31853057114230,
  31853057146998,
  31853057179766,
  31853057212534,
  31853057245302,
  31853057278070,
  31853057310838,
  31853057343606,
  31853057376374,
  31853057409142,
  31853057441910,
  31853057474678,
  31853057507446,
  31853057540214,
  31853057572982,
  31853057605750,
  31853057638518,
  31853057671286,
  31853057736822,
  31853057769590,
  31853057802358,
  31853057835126,
  31853057867894,
  31853057900662,
  31853057933430,
  31853057966198,
  31853057998966,
  31853058031734,
  31853058064502,
  31853058097270,
  31853058130038,
  31853058162806,
  31853058195574,
  31853058228342,
  31853058261110,
  31853058293878,
  31853058326646,
  31853058359414,
  31853058392182,
  31853058424950,
  31853058457718,
  31853058490486,
  31853058523254,
  31853058556022,
  31853058588790,
  31853058621558,
  31853058654326,
  31853058687094,
  31853058719862,
  31853058752630,
  31853058785398,
  31853058818166,
  31853844562038,
  31853844594806,
  31853844627574,
  31853844660342,
  31853844693110,
  31853844725878,
  31853844758646,
  31853844791414,
  31853844824182,
  31853844856950,
  31853844889718,
  31853844922486,
  31853844955254,
  31853844988022,
  31853845020790,
  31853845053558,
  31853845086326,
  31853845119094,
  31853845151862,
  31853845184630,
  31853845217398,
  31853845250166,
  31853845282934,
  31853845315702,
  31853845348470,
  31853845381238,
  31853845414006,
  31853845446774,
  31853845479542,
  31853845512310,
  31853845545078,
  31853845577846,
  31853845610614,
  31853845643382,
  31853845676150,
  31853845708918,
  31853845741686,
  31853845774454,
  31853845807222,
  31853845839990,
  31853845872758,
  31853845905526,
  31853845938294,
  31853845971062,
  31853846003830,
  31853846036598,
  31853846069366,
  31853846102134,
  31853846134902,
  31853846167670,
  31853846200438,
  31853846233206,
  31853846265974,
  31853846298742,
  31853846331510,
  31853846364278,
  31853846397046,
  31853846429814,
  31853846462582,
  31853846495350,
  31853846528118,
  31853846560886,
  31853846593654,
  31853846626422,
  31853846659190,
  31853846691958,
  31853846724726,
  31853846757494,
  31853846790262,
  31853846823030,
  31853846855798,
  31853846888566,
  31853846921334,
  31853846954102,
  31853846986870,
  31853847019638,
  31853847052406,
  31853847085174,
  31853847117942,
  31853847150710,
  31853847183478,
  31853847216246,
  31853847249014,
  31853847281782,
  31853847314550,
  31853847347318,
  31853847380086,
  31853847412854,
  31853847445622,
  31853847478390,
  31853847511158,
  31853847543926,
  31853847576694,
  31853847609462,
  31853847642230,
  31853847707766,
  31853847740534,
  31853847773302,
  31853847806070,
  31853857013878,
  31853859012726,
  31853859045494,
  31853859078262,
  31853859111030,
  31853859143798,
  31853859176566,
  31853859209334,
  31853859242102,
  31853859274870,
  31853859307638,
  31853859340406,
  31853859373174,
  31853859405942,
  31853859438710,
  31853859471478,
  31853859504246,
  31853859537014,
  31853859569782,
  31853859602550,
  31853859635318,
  31853859668086,
  31853859700854,
  31853859733622,
  31853859766390,
  31853859799158,
  31853859831926,
  31853859864694,
  31853859897462,
  31853859930230,
  31853859962998,
  31853859995766,
  31853860028534,
  31853860061302,
  31853860094070,
  31853860126838,
  31853860159606,
  31853860192374,
  31853860225142,
  31853860257910,
  31853860290678,
  31853860323446,
  31853860356214,
  31853860388982,
  31853860421750,
  31853860454518,
  31853860487286,
  31853860520054,
  31853860552822,
  31853860585590,
  31853860618358,
  31853860651126,
  31853860683894,
  31853860716662,
  31853860749430,
  31853860782198,
  31853860814966,
  31853860847734,
  31853860880502,
  31853860913270,
  31853860946038,
  31853860978806,
  31853861011574,
  31853861044342,
  31853861077110,
  31853861109878,
  31853861142646,
  31853861175414,
  31853861208182,
  31853861240950,
  31853861273718,
  31853861306486,
  31853861339254,
  31853861372022,
  31853861404790,
  31853861437558,
  31853861470326,
  31853861503094,
  31853861535862,
  31853861568630,
  31853861601398,
  31853861634166,
  31853861666934,
  31853861699702,
  31853861732470,
  31853861765238,
  31853861798006,
  31853861830774,
  31853861863542,
  31853861896310,
  31853861929078,
  31853861961846,
  31853861994614,
  31853862027382,
  31853862060150,
  31853862092918,
  31853862125686,
  31853862158454,
  31853862191222,
  31853862223990,
  31853862256758,
  31853898596470,
  31853898662006,
  31853898694774,
  31853898727542,
  31853898760310,
  31853898793078,
  31853898825846,
  31853898858614,
  31853898891382,
  31853898924150,
  31853898956918,
  31853898989686,
  31853899022454,
  31853899055222,
  31853899087990,
  31853899120758,
  31853899153526,
  31853899186294,
  31853899219062,
  31853899251830,
  31853899284598,
  31853899317366,
  31853899350134,
  31853899382902,
  31853899415670,
  31853899448438,
  31853899481206,
  31853899513974,
  31853899546742,
  31853899579510,
  31853899612278,
  31853899645046,
  31853899677814,
  31853899710582,
  31853899743350,
  31853899776118,
  31853899808886,
  31853899841654,
  31853899874422,
  31853899907190,
  31853899939958,
  31853899972726,
  31853900005494,
  31853900038262,
  31853900071030,
  31853900103798,
  31853900136566,
  31853900169334,
  31853900202102,
  31853900234870,
  31853900267638,
  31853900300406,
  31853900333174,
  31853900365942,
  31853900398710,
  31853900431478,
  31853900464246,
  31853900497014,
  31853900529782,
  31853900562550,
  31853900595318,
  31853900628086,
  31853900660854,
  31853900693622,
  31853900726390,
  31853900759158,
  31853900791926,
  31853900824694,
  31853900857462,
  31853900890230,
  31853900922998,
  31853900955766,
  31853900988534,
  31853901021302,
  31853901054070,
  31853901086838,
  31853901119606,
  31853901152374,
  31853901185142,
  31853901217910,
  31853901250678,
  31853901283446,
  31853901316214,
  31853901348982,
  31853901381750,
  31853901414518,
  31853901447286,
  31853901480054,
  31853901512822,
  31853901545590,
  31853901578358,
  31853901611126,
  31853901643894,
  31853901676662,
  31853901709430,
  31853901742198,
  31853901774966,
  31853901807734,
  31853901840502,
  31853901873270,
];

const prices = [
  6.0,
  6.1,
  6.2,
  6.3,
  6.4,
  6.5,
  6.6,
  6.7,
  6.8,
  6.9,
  7.0,
  7.1,
  7.2,
  7.3,
  7.4,
  7.5,
  7.6,
  7.7,
  7.8,
  7.9,
  8.0,
  8.1,
  8.2,
  8.3,
  8.4,
  8.5,
  8.6,
  8.7,
  8.8,
  8.9,
  9.0,
  9.1,
  9.2,
  9.3,
  9.4,
  9.5,
  9.6,
  9.7,
  9.8,
  9.9,
  10.0,
  10.1,
  10.2,
  10.3,
  10.4,
  10.5,
  10.6,
  10.7,
  10.8,
  10.9,
  11.0,
  11.1,
  11.2,
  11.3,
  11.4,
  11.5,
  11.6,
  11.7,
  11.8,
  11.9,
  12.0,
  12.1,
  12.2,
  12.3,
  12.4,
  12.5,
  12.6,
  12.7,
  12.8,
  12.9,
  13.0,
  13.1,
  13.2,
  13.3,
  13.4,
  13.5,
  13.6,
  13.7,
  13.8,
  13.9,
  14.0,
  14.1,
  14.2,
  14.3,
  14.4,
  14.5,
  14.6,
  14.7,
  14.8,
  14.9,
  15.0,
  15.1,
  15.2,
  15.3,
  15.4,
  15.5,
  15.6,
  15.7,
  15.8,
  15.9,
  16.0,
  16.2,
  16.4,
  16.6,
  16.8,
  17.0,
  17.2,
  17.4,
  17.6,
  17.8,
  18.0,
  18.2,
  18.4,
  18.6,
  18.8,
  19.0,
  19.2,
  19.4,
  19.6,
  19.8,
  20.0,
  20.2,
  20.4,
  20.6,
  20.8,
  21.0,
  21.2,
  21.4,
  21.6,
  21.8,
  22.0,
  22.2,
  22.4,
  22.6,
  22.8,
  23.0,
  23.2,
  23.4,
  23.6,
  23.8,
  24.0,
  24.2,
  24.4,
  24.6,
  24.8,
  25.0,
  25.2,
  25.4,
  25.6,
  25.8,
  26.0,
  26.2,
  26.4,
  26.6,
  26.8,
  27.0,
  27.2,
  27.4,
  27.6,
  27.8,
  28.0,
  28.2,
  28.4,
  28.6,
  28.8,
  29.0,
  29.2,
  29.4,
  29.6,
  29.8,
  30.0,
  30.2,
  30.4,
  30.6,
  30.8,
  31.0,
  31.2,
  31.4,
  31.6,
  31.8,
  32.0,
  32.2,
  32.4,
  32.6,
  32.8,
  33.0,
  33.2,
  33.4,
  33.6,
  33.8,
  34.0,
  34.2,
  34.4,
  34.6,
  34.8,
  35.0,
  35.2,
  35.4,
  35.6,
  35.8,
  36.0,
  36.5,
  37.0,
  37.5,
  38.0,
  38.5,
  39.0,
  39.5,
  40.0,
  40.5,
  41.0,
  41.5,
  42.0,
  42.5,
  43.0,
  43.5,
  44.0,
  44.5,
  45.0,
  45.5,
  46.0,
  46.5,
  47.0,
  47.5,
  48.0,
  48.5,
  49.0,
  49.5,
  50.0,
  50.5,
  51.0,
  51.5,
  52.0,
  52.5,
  53.0,
  53.5,
  54.0,
  54.5,
  55.0,
  55.5,
  56.0,
  56.5,
  57.0,
  57.5,
  58.0,
  58.5,
  59.0,
  59.5,
  60.0,
  60.5,
  61.0,
  61.5,
  62.0,
  62.5,
  63.0,
  63.5,
  64.0,
  64.5,
  65.0,
  65.5,
  66.0,
  66.5,
  67.0,
  67.5,
  68.0,
  68.5,
  69.0,
  69.5,
  70.0,
  70.5,
  71.0,
  71.5,
  72.0,
  72.5,
  73.0,
  73.5,
  74.0,
  74.5,
  75.0,
  75.5,
  76.0,
  76.5,
  77.0,
  77.5,
  78.0,
  78.5,
  79.0,
  79.5,
  80.0,
  80.5,
  81.0,
  81.5,
  82.0,
  82.5,
  83.0,
  83.5,
  84.0,
  84.5,
  85.0,
  85.5,
  86.0,
  87.0,
  88.0,
  89.0,
  90.0,
  91.0,
  92.0,
  93.0,
  94.0,
  95.0,
  96.0,
  97.0,
  98.0,
  99.0,
  100.0,
  101.0,
  102.0,
  103.0,
  104.0,
  105.0,
  106.0,
  107.0,
  108.0,
  109.0,
  110.0,
  111.0,
  112.0,
  113.0,
  114.0,
  115.0,
  116.0,
  117.0,
  118.0,
  119.0,
  120.0,
  121.0,
  122.0,
  123.0,
  124.0,
  125.0,
  126.0,
  127.0,
  128.0,
  129.0,
  130.0,
  131.0,
  132.0,
  133.0,
  134.0,
  135.0,
  136.0,
  137.0,
  138.0,
  139.0,
  140.0,
  141.0,
  142.0,
  143.0,
  144.0,
  145.0,
  146.0,
  147.0,
  148.0,
  149.0,
  150.0,
  151.0,
  152.0,
  153.0,
  154.0,
  155.0,
  156.0,
  157.0,
  158.0,
  159.0,
  160.0,
  161.0,
  162.0,
  163.0,
  164.0,
  165.0,
  166.0,
  167.0,
  168.0,
  169.0,
  170.0,
  171.0,
  172.0,
  173.0,
  174.0,
  175.0,
  176.0,
  177.0,
  178.0,
  179.0,
  180.0,
  181.0,
  182.0,
  183.0,
  184.0,
  185.0,
];

const mindestpreis = 12;
const aussenformAufpreis = 8;
const konturAufpreis = 12;
const preisProQM = 60;

export default class AppSVG extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      file: "",
      numPages: null,
      pageNumber: 1,
      lastUserInputField: "hoehe",
      ausschnittAufpreis: 0,
      lastUserInput: 5,
      ratio: 1,
      menge: 1,
      preisError: false, // wenn bild zu klein
      errorText: "",
      warenkorbText: "",
      ausschnitt: "rechteckig",
      listItems: [{ text: "", color: "black" }],
      colorPaletteOpen: false,
      lastOpenedColor: null,
    };
    this.openColorPalette = this.openColorPalette.bind(this);
    this.handleChangeComplete = this.handleChangeComplete.bind(this);
    this.setInput = this.setInput.bind(this);
    this.setMenge = this.setMenge.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }
  openColorPalette(index) {
    const palette = document.getElementById("color-palette");
    if (!this.state.colorPaletteOpen) {
      this.setState({ lastOpenedColor: index });
      palette.classList.remove("hidden");
      this.setState({ colorPaletteOpen: true });
    } else {
      palette.classList.add("hidden");
      this.setState({ colorPaletteOpen: false });
    }
  }

  handleChange(e, index, property) {
    // update state
    let newListItems = this.state.listItems;
    newListItems[index][property] = e.target.value;

    // delete row if empty
    if (!e.target.value) {
      newListItems.splice(index, 1);
    }

    const filteredItems = newListItems.filter((item) => item.text);

    filteredItems.push({ text: "", color: "black" });

    this.setState({ listItems: filteredItems });
  }

  handleChangeComplete(color) {
    let newListItems = this.state.listItems;
    newListItems[this.state.lastOpenedColor].color = color.hex;
    this.setState({ listItems: newListItems });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const file = document.getElementById("my_img_field").files[0];
    const fr = new FileReader();
    fr.readAsDataURL(file);

    const img = document.getElementById("mk-aufkleber-vorschau-img");
    const that = this;

    if (file.type.includes("pdf")) {
      img.src = "";
      fr.onload = function(e) {
        that.setState({ file: this.result });
        setTimeout(() => {
          const pdf = document.getElementsByClassName(
            "react-pdf__Page__canvas"
          );
          let ratio = pdf[0].clientWidth / pdf[0].clientHeight;
          that.setState({ ratio: ratio });
        }, 1000);
      };
    } else {
      this.setState({ file: "" });
      fr.onload = await function(e) {
        img.src = this.result;
        that.setState({ file: this.result });
        setTimeout(() => {
          let ratio =
            document.getElementById("mk-aufkleber-vorschau-img").clientWidth /
            document.getElementById("mk-aufkleber-vorschau-img").clientHeight;
          that.setState({ ratio: ratio });
        }, 1000);
      };
    }
  }

  //anpassen, nach mirkos infos und nutzen
  checkPreisError(input, ratio, inputField) {
    let upperEnd = 400;
    let that = this;
    function setError(bool) {
      that.setState({ preisError: bool });
    }
    let opposite;
    if (inputField == "hoehe") {
      opposite = input * ratio;
    }
    if (inputField == "breite") {
      opposite = input / ratio;
    }
    let area = opposite * input;
    if (input < 1 || input > upperEnd || opposite < 1 || opposite > upperEnd) {
      this.setState({
        errorText: `Die Seitenlängen müssen zwischen 1 - ${upperEnd} cm liegen!`,
      });
      setError(true);
    } else if (area > 40000) {
      this.setState({
        errorText: "Die ausgewähle Fläche ist zu groß!",
      });
      setError(true);
    } else if (opposite > 120 && input > 120) {
      this.setState({
        errorText: "Nur eine der beiden Seiten darf über 120 cm groß sein!",
      });
      setError(true);
    } else {
      this.setState({ errorText: "" });
      setError(false);
    }
  }

  setInput(e) {
    this.setState({ lastUserInput: e.target.value });
    this.setState({ lastUserInputField: e.target.id });
    this.checkPreisError(e.target.value, this.state.ratio, e.target.id);
  }

  setMenge(e) {
    this.setState({ menge: e.target.value });
  }

  async uploadImage(uniq) {
    const files = this.state.file; //e.target.files
    const data = new FormData();
    data.append("file", files);
    data.append("upload_preset", "folienhain");
    data.append("public_id", uniq);

    const res = await fetch(
      "https://api.cloudinary.com/v1_1/dsinawpna/image/upload",
      {
        method: "POST",
        body: data,
      }
    );
  }

  async addToCart() {
    const inputField = this.state.lastUserInputField;
    const input = this.state.lastUserInput;
    const ratio = this.state.ratio;
    let hoeheBerechnet = input / ratio;
    hoeheBerechnet = hoeheBerechnet.toFixed(1);
    let breiteBerechnet = input * ratio;
    breiteBerechnet = breiteBerechnet.toFixed(1);
    let hoehe = inputField === "breite" ? hoeheBerechnet : input;
    let breite = inputField === "hoehe" ? breiteBerechnet : input;
    let flaecheInCM = breite * hoehe;
    let flaeche = flaecheInCM / 10000;
    let preis = preisProQM * flaeche;

    // todo implement file upload
    var uniq = "id" + new Date().getTime();

    await this.uploadImage(uniq);

    if (this.state.ausschnitt === "rechteckig") {
      let result = 6;
      (function() {
        for (let i = 0; i < prices.length; i++) {
          if (preis <= prices[i]) {
            result = i;
            return;
          }
          counter = counter + 1;
        }
      })();
    } else if (this.state.ausschnitt === "aussenform") {
      preis = preis + aussenformAufpreis;
      let result = 8;
      (function() {
        for (let i = 0; i < prices.length; i++) {
          if (preis <= prices[i]) {
            result = i;
            return;
          }
          counter = counter + 1;
        }
      })();
    } else if (this.state.ausschnitt === "kontur") {
      preis = preis + konturAufpreis;
      let result = 8;
      (function() {
        for (let i = 0; i < prices.length; i++) {
          if (preis <= prices[i]) {
            result = i;
            return;
          }
          counter = counter + 1;
        }
      })();
    }
    // preis = prices[result];
    if (preis < mindestpreis) {
      preis = mindestpreis;
    }

    let x = preis;
    let counter = 0;
    let error = false;
    let result = 6;
    (function() {
      for (let i = 0; i < prices.length; i++) {
        if (x <= prices[i]) {
          result = i;
          return;
        }
        counter = counter + 1;
        error = true;
      }
    })();
    if (this.state.file) {
      jQuery.post("/cart/add.js", {
        items: [
          {
            quantity: this.state.menge,
            id: variantNumber[result],
            properties: {
              // _File: this.state.file,
              Größe: breite + " cm * " + hoehe + " cm",
              Außenform: this.state.ausschnitt,
              _idCl: uniq,
              _infoo: JSON.stringify(this.state.listItems),
            },
          },
        ],
      });
      this.setState({
        warenkorbText: "Artikel wurde in den Einkaufswagen gelegt!",
      });
    } else {
      this.setState({
        warenkorbText: "Bitte ein File auswählen...",
      });
    }
    setTimeout(() => {
      this.setState({
        warenkorbText: "",
      });
    }, 2000);
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages });
  }

  chooseAusschnitt(ausschnitt) {
    this.setState({ ausschnitt: ausschnitt });
  }

  render() {
    return (
      <div className="mk-app">
        {/* Header block */}
        <div className="mk-100vw ">
          <div className="mk-text-left mk-bg-blue">
            <h1 className="mk-title">SVG's drucken</h1>
            <ul className="mk-ul-circle">
              <li>UV- und witterungsbeständig.</li>
              <li>waschstraßenfest</li>
              <li>langlebig</li>
              <li>rückstandslos entfernbar</li>
              <li>erhältlich in über 100 satten Farben</li>
            </ul>
          </div>
          <div className="mk-boxes-right">
            <div className="mk-square-1 mk-square"></div>
            <div className="mk-square-2 mk-square"></div>
            <div className="mk-square-3 mk-square"></div>
          </div>
        </div>

        <div className="row mk-row">
          <BoxAufkleber number="1" title="Datei hochladen">
            <div className="mk-flex">
              <form
                id="mk-upload-file"
                // onSubmit={this.handleSubmit}
              >
                <input
                  id="my_img_field"
                  type="file"
                  ref={this.fileInput}
                  onChange={(e) => {
                    this.handleSubmit(e);
                  }}
                />
                <label htmlFor="my_img_field">
                  <span id="mk-choose-file">Datei auswählen...</span>
                </label>
              </form>
              <p className="mk-p-klein" id="mk-upload-file-info">
                Datei Formate: JPEG, PNG, BMP, SVG, PDF
              </p>
            </div>
          </BoxAufkleber>
          <BoxAufkleber number="2" title="Grösse & Preis">
            <PreisBerechnerAufkleber
              ratio={this.state.ratio}
              lastUserInputField={this.state.lastUserInputField}
              lastUserInput={this.state.lastUserInput}
              preisError={this.state.preisError}
              menge={this.state.menge}
              ausschnitt={this.state.ausschnitt}
              setInput={this.setInput}
              setMenge={this.setMenge}
              errorText={this.state.errorText}
              farbenAufpreis={this.state.ausschnittAufpreis}
            />
          </BoxAufkleber>
        </div>

        <div className="row mk-row">
          <BoxAufkleber
            number="3"
            title="Beschreibe deinen Aufkleber"
            customClass="mk-align-top customize"
          >
            <div>
              {this.state.listItems.map((listItem, index) => {
                return (
                  <ListItem key={index}>
                    <p>{index + 1}.</p>
                    <input
                      placeholder='z.B. "Logo", "Schrift", etc.'
                      type="text"
                      value={listItem.text}
                      onChange={(e) => this.handleChange(e, index, "text")}
                    />
                    <ColorPicker
                      index={index}
                      openColorPalette={() => this.openColorPalette(index)}
                      handleChangeComplete={this.handleChangeComplete}
                      color={this.state.listItems[index].color}
                    />
                  </ListItem>
                );
              })}
            </div>
          </BoxAufkleber>
        </div>

        <div className="row mk-row">
          <BoxAufkleber number="4" title="Form" customClass="mk-align-top">
            <Form
              chooseAusschnitt={(ausschnitt) =>
                this.chooseAusschnitt(ausschnitt)
              }
            />
          </BoxAufkleber>

          <BoxAufkleber number="5" title="Datei Vorschau">
            <div id="mk-aufkleber-vorschau">
              <img src="" id="mk-aufkleber-vorschau-img" alt="" />
              <Document file={this.state.file} onLoadError={console.error}>
                <Page pageNumber={1} width={350} />
              </Document>
            </div>
          </BoxAufkleber>
        </div>
        <div id="mk-warenkorb-text">
          <p>{this.state.warenkorbText}</p>
        </div>
        <button
          onClick={this.addToCart}
          className="btn product-form__cart-submit w3-options-add-to-cart"
          id="mk-cart-button"
        >
          <span id="AddToCartText-product-template">
            In den Einkaufswagen legen
          </span>
        </button>
        <a
          href="/cart"
          className="btn product-form__cart-submit w3-options-add-to-cart mk-margin-top-44"
          id="mk-cart-button"
        >
          <span id="AddToCartText-product-template">Zum Einkaufswagen</span>
        </a>

        <hr />
        {/* BOTTOM 1 */}
        <div>
          <div className="mk-bottom-1">
            <div>
              <h1>Echte Markequalität made in Germany</h1>
              <p>
                Wir produzieren unsere Aufkleber aus einer hochwertigen Folie,
                welche extra für den Außenbereich ausgelegt ist. Somit ist die
                Folie robust, langlebig(bis zu 10 Jahre), waschstraßenfest und
                rückstandslos entfernbar. Bei uns erhalten Sie zudem keine
                Lagerware, da wir unsere Aufkleber erst bei Bestellung
                produzieren.
              </p>
            </div>
            <img
              src="https://res.cloudinary.com/dsinawpna/image/upload/v1613690751/for-page/c1t0kpziavtjvbqr7fy4.png"
              alt=""
            />
          </div>
          <div className="mk-bottom-1">
            <img
              src="https://res.cloudinary.com/dsinawpna/image/upload/v1613690751/for-page/ov37qovuyxoundq6ofuy.jpg"
              alt=""
            />
            <div>
              <h1>Satte und volle Farben</h1>
              <p>
                Sie haben Auswahl aus einem großen Sortiment Folien. Es sind
                alle Standardfarben, einige Pastellfarben und 3 Farben in
                metallic erhältlich. Zudem können Sie sich zwischen matt und
                glänzend entscheiden.
              </p>
            </div>
          </div>
        </div>
        {/* BOTTOM 2 */}
        <div className="mk-bottom-2">
          <h1 style={{ fontWeight: 600, marginBottom: "2rem" }}>
            Häufige Fragen zu Klebeschriften
          </h1>
          <div>
            <div className="mk-bottom-2-1">
              <div className="mk-bottom-2-1-1">
                <h2>Wie werden die Klebebuchstaben geliefert?</h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Die eigentliche Klebefolie liegt auf einem
                  silikonbeschichteten Papier. Über das Motiv ist eine
                  durchsichtige Transferfolie kaschiert, mit dieser Sie das
                  Motiv oder Klebeschrift auf den Untergrund anbringen können.
                </p>
              </div>
              <div className="mk-bottom-2-1-1">
                <h2>Was benötige ich für eine Montage der Klebeschrift?</h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Für die Verklebung des Aufklebers benötigen Sie einen Rakel
                  (kann mitbestellt werden), alternativ können Sie ein Stofftuch
                  um eine Checkkarte wickeln und diese zu einer Anbringhilfe
                  umfunktionieren, Klebeband, fusselfreies Tuch, Wasserwaage,
                  Zollstock oder Maßband und genügend Zeit. Eine ausführliche
                  Verklebeanleitung finden Sie HIER
                </p>
              </div>
            </div>
            <div className="mk-bottom-2-1">
              <div className="mk-bottom-2-1-1">
                <h2>
                  Woher weiß ich, ob ein Untergrund zum bekleben geeignet ist?
                </h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Klebe einen etwas längeren Tesafilmstreifen auf den
                  ausgewählten Untergrund. Hält der Streifen, wird auch die
                  Folie halten. Falls du dir dennoch nicht sicher bist, kannst
                  du einen kostenlosen Testaufkleber bestellen. Schreiben Sie
                  uns einfach eine Mail an{" "}
                  <a
                    style={{
                      color: "white",
                      textDecoration: "underline",
                    }}
                    href="mailto:info@folienhain.de"
                  >
                    info@folienhain.de
                  </a>
                </p>
              </div>
              <div className="mk-bottom-2-1-1">
                <h2>
                  Kann ich mit dem Aufkleber durch die Waschanlage fahren?
                </h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Ja, unsere Klebebuchstaben sind waschstraßenfest!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
